import { useTheme } from "@mui/material";
import { useMemo } from "react";

export const useResolveBorderColor = (
  hover: boolean | undefined,
  error?: boolean | undefined
) => {
  const theme = useTheme();
  return useMemo(() => {
    return error === true
      ? theme.palette.error.main
      : theme.palette.mode === "light"
      ? hover
        ? "rgba(0, 0, 0, 0.87)"
        : "rgba(0, 0, 0, 0.23)"
      : hover
      ? "#ebebeb"
      : "rgba(255, 255, 255, 0.23)";
  }, [error, hover, theme.palette.error.main, theme.palette.mode]);
};
